// extracted by mini-css-extract-plugin
module.exports = {"performance":"LoadingIndicator_performance__1Kyhb","rotation":"LoadingIndicator_rotation__U6kiZ"};